import React, { useState } from 'react';
import { ImageUpload } from 'components/formInputs/imageUpload';
import { DropDownList } from 'components/formInputs/dropDownList';
import { Config } from 'configs';
import { SelectedItemButton } from 'components/buttons/selectedItemButton';

export const MenuCategoryImages = ({
  id, usedLanguages, languages, images,
  onLanguageChange, onImageChange,
}) => {
  const [coverImages, setCoverImages] = useState(images || []);
  const [selectedLanguages, setSelectedLanguages] = useState(languages || []);

  const renderSelectedRestaurants = () => {
    if (!selectedLanguages) return null;

    return (
      <div>
        {selectedLanguages.map((lang) => {
          return (
            <div className="mt-2" key={lang}>
              <SelectedItemButton
                key={lang}
                name={lang}
                onClick={() => {
                  const newRestaurants = selectedLanguages.filter((x) => x !== lang);

                  setSelectedLanguages(newRestaurants);
                  onLanguageChange(newRestaurants);
                }}
              />
            </div>
          );
        })}
      </div>
    );
  };

  const getLanguagesDataSource = () => {
    const allLanguages = [{ value: '-1', label: '-' }, { value: 'all', label: 'all' }, ...Config.AVAILABLE_LANGUAGES.map((val) => ({ label: val, value: val }))];

    return allLanguages
      ?.filter((r) => !selectedLanguages.includes(r.value) && (!usedLanguages || !usedLanguages.includes(r.value)))
      .map((lang) => ({
        label: lang.label,
        value: lang.value,
      }));
  };

  return (
    <div className="w-full grid grid-cols-6 gap-6">

      <div className="col-span-6 lg:col-span-3">
        <DropDownList
          showLabel
          label="Languages*"
          options={getLanguagesDataSource()}
          className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
          onChange={(e) => {
            const newVal = [...selectedLanguages, e.target.value];

            setSelectedLanguages(newVal);
            onLanguageChange(newVal);
          }}
        />
        {renderSelectedRestaurants()}
      </div>

      <div className="col-span-6 md:col-span-3">
        <label className="block text-sm font-medium text-gray-700">Images</label>
        <ImageUpload
          id={id}
          images={coverImages}
          onChange={(val) => {
            setCoverImages(val);
            onImageChange(val);
          }}
          multiple
        />
      </div>

    </div>
  );
};
